import React from "react";
import Container from "../Layout/Container";
import { connect } from "react-redux";
import {
  getPickupAddresses,
  postPickupAddress,
  deletePickupAddress,
  updatePickupAddress,
  clearErrors,
} from "../../redux/Actions/pickupAddressAction";
import { getCountries } from "../../redux/Actions/countryAction";
import PickupAddressEditModal from "./Items/PickupAddressEditModal";
import ContentBlock from "../Layout/ContentBlock";
import Pagination from "../Dashboard/items/Pagination";
import TableColumnPickupAddress from "./Items/TableColumnPickupAddress";
import FilterMenu from "../Layout/FilterMenu";
import TableFilterBox from "../common/TableFilterBox";
import ContentValidation from "../common/ContentValidation";

class PickupAddresses extends React.Component {
  constructor() {
    super();
    this.state = {
      requiredId: 0,
      page: 1,
      pageCount: 100,
      action: "new",
    };
  }
  componentDidMount() {
    this.props.getPickupAddresses(this.state.page, this.state.pageCount);
    this.props.getCountries(1, 500);
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.page !== this.state.page ||
      prevState.pageCount !== this.state.pageCount
    ) {
      this.props.getPickupAddresses(this.state.page, this.state.pageCount);
    }
  }

  onAction = (action, index) => {
    this.setState({
      requiredId: index,
      action: action,
    });
  };

  setPagination = (page) => {
    this.setState({
      page,
    });
  };
  setPageCount = (pageCount) => {
    this.setState({
      pageCount,
      page: 1,
    });
  };

  render() {
    const requiredItem = this.state.requiredId;
    let modalData = this.props.pickupAddressesItems[requiredItem]
      ? this.props.pickupAddressesItems[requiredItem]
      : [];
    return (
      <Container
        location={{
          locationName: "Paėmimo adresai",
          locationUrl: this.props.match.url,
        }}
      >
        <ContentBlock>
          <FilterMenu
            length={`${this.props.totals || 0} / ${
              this.props.pickupAddressesItems.length || 0
            }`}
            onChangeCountPage={this.setPageCount}
            countPage={this.state.pageCount}
            text="paėmimo adresų"
            text2="Paėmimo adresų"
          />
        </ContentBlock>
        <ContentBlock>
          <TableFilterBox filter={false} add={this.onAction}></TableFilterBox>
          <div>
            <ContentValidation
              loader={this.props.loading_pickupAddress}
              array={this.props.pickupAddressesItems}
              alertId_s="pickupAlert-s"
              alertId_e="pickupAlert-e"
            >
              <div className="table-responsive">
                <table className="table table-sm table-hover mt-3">
                  <thead>
                    <tr className="text-muted">
                      <th className="text-black">#</th>
                      <th className="text-black">Kodas</th>
                      <th className="text-black">Įmonė</th>
                      <th className="text-black">Kontaktinis asmuo</th>
                      <th className="text-black">Adresas</th>
                      <th className="text-black">Miestas</th>
                      <th className="text-black">Šalis</th>
                      <th className="text-black">Pašto kodas</th>
                      <th className="text-black">Telefonas</th>
                      <th className="text-black">Darbo laikas</th>
                      <th className="text-black">El. paštas</th>
                      <th className="text-black">Aktyvus?</th>
                      <th className="text-black">Komentarai</th>
                      <th></th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.pickupAddressesItems.map((item, index) => {
                      return (
                        <TableColumnPickupAddress
                          key={index}
                          index={index}
                          item={item}
                          onEdit={this.onAction}
                          onDelete={this.props.deletePickupAddress}
                        />
                      );
                    })}
                  </tbody>
                </table>
                <Pagination
                  setPagination={this.setPagination}
                  page={this.state.page}
                  totals={this.props.totals}
                  pageCount={this.state.pageCount}
                />
              </div>
            </ContentValidation>
          </div>
        </ContentBlock>
        <PickupAddressEditModal
          action={this.state.action}
          postPickupAddress={this.props.postPickupAddress}
          updatePickupAddress={this.props.updatePickupAddress}
          objectData={modalData}
          clearErrors={this.props.clearErrors}
          countries={this.props.countries || []}
          errors={this.props.errors}
        />
      </Container>
    );
  }
}
const mapStateToProps = (state) => ({
  pickupAddressesItems: state.pickupAddress.pickupAddresses,
  totals: state.pickupAddress.totals,
  loading_pickupAddress: state.pickupAddress.loading_pickupAddress,
  countries: state.country.countries,
  errors: state.errors,
});

export default connect(mapStateToProps, {
  getPickupAddresses,
  postPickupAddress,
  deletePickupAddress,
  updatePickupAddress,
  getCountries,
  clearErrors,
})(PickupAddresses);
